import { ACADEMY_ROUTES } from '@/shared/academy.const'

export const TUTORIAL_MENU_DEFAULTS = {
  basePath: ACADEMY_ROUTES.quickStart,
  title: 'Quick Start Guide',
} as const
